import apiFetch from "@wordpress/api-fetch";
import { useState, useCallback } from "react";
import { useMultiSiteContext } from "@hooks/use-site-context";

const WP_API_URL = "wp-json/wp/v2/";

export type WpTaxonomyValue = {
  count: number;
  description: string;
  id: number;
  link: string;
  meta: any;
  meta_box: any;
  name: string;
  parent: number;
  slug: string;
  taxonomy: string;
};

const getTaxonomyValue = async (url: string) =>
  apiFetch({
    url: url,
  });

export const useGetTaxonomyValues = () => {
  const [state, setState] = useState<[WpTaxonomyValue[]]>([[]]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const { getApiUrl } = useMultiSiteContext();

  const getTaxonomies = useCallback(
    async (ids: string[]): Promise<[WpTaxonomyValue[]] | undefined> => {
      setLoading(true);
      try {
        const responses = (await Promise.all(
          ids?.map((id) => getTaxonomyValue(getApiUrl(`${WP_API_URL}${id}`))) ||
            []
        )) as [WpTaxonomyValue[]];
        setState(responses);
        return responses;
      } catch (err) {
        setError("Error fetching taxonomy values: " + (err as Error)?.message);
        setLoading(false);
        return;
      }
    },
    [getApiUrl]
  );

  return {
    getTaxonomies,
    taxonomyValues: state,
    loading,
    error,
  };
};
